import React, { useState, useEffect } from "react";
import { Loader2, Check, AlertCircle } from "lucide-react";
import "./UnitModal.scss";
import { errorAlert } from "../../Components/Alerts";
import TextField from "@mui/material/TextField";

export default function UnitModal({ isOpen, onClose, onSave, initialData }) {
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showUnsavedAlert, setShowUnsavedAlert] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setName(initialData.UnitName);
        setIsActive(initialData.IsActive);
      } else {
        setName("");
        setIsActive(true);
      }
      setIsDirty(false);
    }
  }, [isOpen, initialData]);

  const handleNameChange = (e) => {
    setName(e.target.value);
    setIsDirty(true);
  };

  const handleActiveChange = () => {
    setIsActive((prev) => !prev);
    setIsDirty(true);
  };

  const handleCloseAttempt = () => {
    if (isDirty) setShowUnsavedAlert(true);
    else onClose();
  };

  const handleConfirmClose = () => {
    setShowUnsavedAlert(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    setIsSubmitting(true);

    try {
      const payload = {
        UnitName: name.trim(),
        IsActive: isActive,
        ...(initialData?.UnitID && { UnitID: initialData.UnitID }),
      };
      await onSave(payload);
      setIsDirty(false);
      onClose();
    } catch (err) {
      errorAlert("Failed to save unit", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="unit-modal-overlay">
      <div className="unit-modal-container">
        <div className="unit-modal-header">
          <h2 className="unit-modal-title">
            {initialData ? "Edito Njesin" : "Njësi e re"}
          </h2>
          <p className="unit-modal-description">
            {initialData
              ? "Përditëso detajet e njësisë matëse më poshtë."
              : "Plotëso detajet për të krijuar një njësi të re matëse."}
          </p>
        </div>

        <form className="unit-modal-form" onSubmit={handleSubmit}>
          <div className="UnitForm__form-group">
            <TextField
              id="name"
              label="Emërtimi njësisë *"
              variant="filled"
              value={name}
              onChange={handleNameChange}
              placeholder="e.g. Kilogram"
              autoFocus
              fullWidth
              error={!name.trim() && isDirty}
              helperText={
                !name.trim() && isDirty ? (
                  <span className="unit__error-text">
                    <AlertCircle className="error-icon" /> Plotesoni emertimin
                  </span>
                ) : null
              }
            />
          </div>

          <div
            className="form-group checkbox-group"
            onClick={handleActiveChange}
          >
            <div
              className={`form-checkbox-wrapper ${isActive ? "checked" : ""}`}
            >
              {isActive && <Check className="check-icon" />}
            </div>
            <div className="checkbox-labels">
              <label htmlFor="isActive" className="checkbox-label">
                Statusi Aktiv
              </label>
              <p className="checkbox-description">
                Aktivizo ose çaktivizo këtë njësi në sistem.
              </p>
            </div>
          </div>

          <div className="ArticleUnit__modal__footer">
            <button
              type="button"
              onClick={handleCloseAttempt}
              className="ArticleUnit__btn ArticleUnit__btn--outline"
            >
              Mbyll
            </button>

            <button
              type="submit"
              disabled={!name.trim() || isSubmitting}
              className="ArticleUnit__btn ArticleUnit__btn--primary"
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="ArticleUnit__btn__loader" />
                  Duke u ruajtur...
                </>
              ) : (
                "Ruaj Njësin"
              )}
            </button>
          </div>
        </form>

        {showUnsavedAlert && (
          <div className="unit-alert-dialog">
            <div className="alert-content">
              <h3 className="alert-title">Njoftim</h3>
              <p className="alert-description">
                Disa ndryshime nuk janë ruajtur. Nëse e mbyllni formularin, ato
                do të humbasin.
              </p>
              <div className="alert-footer">
                <button
                  onClick={() => setShowUnsavedAlert(false)}
                  className="btn btn-outline"
                >
                  Vazhdo editimin
                </button>
                <button onClick={handleConfirmClose} className="btn btn-danger">
                  Fshij & mbyll formën
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// import React, { useState, useEffect } from "react";
// import { Loader2, Check, AlertCircle } from "lucide-react"; // përdor Check për checkbox
// import "./UnitModal.scss";
// import { errorAlert } from "../../Components/Alerts";
// import TextField from "@mui/material/TextField";
// // import { AlertCircle } from "lucide-react";

// export default function UnitModal({ isOpen, onClose, onSave, initialData }) {
//   const [name, setName] = useState("");
//   const [isActive, setIsActive] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showUnsavedAlert, setShowUnsavedAlert] = useState(false);
//   const [isDirty, setIsDirty] = useState(false);

//   useEffect(() => {
//     if (isOpen) {
//       if (initialData) {
//         setName(initialData.UnitName);
//         setIsActive(initialData.IsActive);
//       } else {
//         setName("");
//         setIsActive(true);
//       }
//       setIsDirty(false);
//     }
//   }, [isOpen, initialData]);

//   const handleNameChange = (e) => {
//     setName(e.target.value);
//     setIsDirty(true);
//   };

//   const handleActiveChange = () => {
//     setIsActive((prev) => !prev);
//     setIsDirty(true);
//   };

//   const handleCloseAttempt = () => {
//     if (isDirty) setShowUnsavedAlert(true);
//     else onClose();
//   };

//   const handleConfirmClose = () => {
//     setShowUnsavedAlert(false);
//     onClose();
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!name.trim()) return;

//     setIsSubmitting(true);

//     try {
//       // Për update, përfshij UnitID nga initialData
//       const payload = {
//         UnitName: name.trim(),
//         IsActive: isActive,
//         ...(initialData?.UnitID && { UnitID: initialData.UnitID }), // <--- kjo
//       };

//       await onSave(payload);

//       setIsDirty(false);
//       onClose();
//     } catch (err) {
//       errorAlert("Failed to save unit", err);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="modal-container">
//         <div className="modal-header">
//           <h2 className="modal-title">
//             {initialData ? "Edito Njesin" : "Njësi e re"}
//           </h2>
//           <p className="modal-description">
//             {initialData
//               ? "Përditëso detajet e njësisë matëse më poshtë."
//               : "Plotëso detajet për të krijuar një njësi të re matëse."}
//           </p>
//         </div>

//         <form className="modal-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <TextField
//               id="name"
//               label="Emërtimi njësisë *"
//               variant="filled"
//               value={name}
//               onChange={handleNameChange}
//               placeholder="e.g. Kilogram"
//               autoFocus
//               fullWidth
//               error={!name.trim() && isDirty} // aktivizon gjendjen e gabimit
//               helperText={
//                 !name.trim() && isDirty ? (
//                   <span
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "4px",
//                     }}
//                   >
//                     <AlertCircle className="error-icon" /> Plotesoni emertimin
//                   </span>
//                 ) : null
//               }
//             />

//             {/* <label htmlFor="name" className="form-label">
//               Emertimi njësisë <span className="required">*</span>
//             </label>
//             <input
//               id="name"
//               type="text"
//               value={name}
//               onChange={handleNameChange}
//               placeholder="e.g. Kilogram"
//               autoFocus
//               className="form-input"
//             />
//             {!name.trim() && isDirty && (
//               <p className="form-error">
//                 <AlertCircle className="error-icon" /> Plotesoni emertimin
//               </p>
//             )} */}
//           </div>

//           <div
//             className="form-group checkbox-group"
//             onClick={handleActiveChange}
//           >
//             <div
//               className={`form-checkbox-wrapper ${isActive ? "checked" : ""}`}
//             >
//               {isActive && <Check className="check-icon" />}
//             </div>
//             <div className="checkbox-labels">
//               <label htmlFor="isActive" className="checkbox-label">
//                 Statusi Aktiv
//               </label>
//               <p className="checkbox-description">
//                 Aktivizo ose çaktivizo këtë njësi në sistem.
//               </p>
//             </div>
//           </div>

//           <div className="modal-footer">
//             <button
//               type="button"
//               onClick={handleCloseAttempt}
//               className="btn btn-outline"
//             >
//               Mbyll
//             </button>
//             <button
//               type="submit"
//               disabled={!name.trim() || isSubmitting}
//               className="btn btn-primary"
//             >
//               {isSubmitting ? (
//                 <>
//                   <Loader2 className="loader" /> Duke u ruajtur...
//                 </>
//               ) : (
//                 "Ruaj Njesin"
//               )}
//             </button>
//           </div>
//         </form>

//         {showUnsavedAlert && (
//           <div className="alert-dialog">
//             <div className="alert-content">
//               <h3 className="alert-title">Njoftim</h3>
//               <p className="alert-description">
//                 Disa ndryshime nuk janë ruajtur. Nëse e mbyllni formularin, ato
//                 do të humbasin.
//               </p>
//               <div className="alert-footer">
//                 <button
//                   onClick={() => setShowUnsavedAlert(false)}
//                   className="btn btn-outline"
//                 >
//                   Vazhdo editimin
//                 </button>
//                 <button onClick={handleConfirmClose} className="btn btn-danger">
//                   Fshij & mbyll formën
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }
